import { hasValue } from '@famly/stat_ts-utils_has-value';
/**
 * The parsed body of a failed request: Apollo 3's and the REST link's `result`, or Apollo 4's raw
 * `bodyText` parsed. `null` without a JSON body, as for a dropped connection or an HTML error page.
 */
export const readServerErrorBody = (error) => {
    if (!hasValue(error) || typeof error !== 'object') {
        return null;
    }
    const { result, bodyText } = error;
    if (hasValue(result)) {
        return result;
    }
    if (typeof bodyText !== 'string') {
        return null;
    }
    try {
        return JSON.parse(bodyText);
    }
    catch (_a) {
        return null;
    }
};
